import { Details } from '../details';

import { RiaTable } from './RiaTable';
import { ExpandMoreIcon } from './icons';

type FeeRow = {
  type: string;
  description: string;
  typicalCost: string;
};

const FEE_STRUCTURES: FeeRow[] = [
  {
    type: 'Investment advisor\nassets under management (AUM)',
    description: 'Managing your portfolio of stocks, bonds and other investment products.',
    typicalCost: '0.25% to 0.50% annually for a robo-advisor; about 1% for an investment advisor.',
  },
  {
    type: 'Flat annual fee (retainer)',
    description:
      'Generally paid to an investment advisor or financial planner for special projects, such as analyzing whether to buy or sell your business. May also provide more access to the financial advisor.',
    typicalCost: 'Typically $2,500 to $9,200.',
  },
  {
    type: 'Hourly fee',
    description:
      'Generally paid to an investment advisor or financial planner for special projects, such as helping create a financial plan for a specific situation, such as a divorce.',
    typicalCost: '$200 to $400.',
  },
  {
    type: 'Financial planning',
    description: 'Creating a detailed, written comprehensive financial plan for a client.',
    typicalCost: 'Typically $3,000, but varies by service.',
  },
  {
    type: 'Transaction costs and expense ratios',
    description:
      'Paid to a broker dealer for investments in mutual funds, ETFs and similar instruments.',
    typicalCost: 'Varies; expense ratios may range 0.05% to 0.75%.',
  },
  {
    type: 'Custodial fees',
    description: 'Fees that the custodian charges you to hold your assets.',
    typicalCost:
      'May be around 0.10% to 0.15%, but varies by account size, asset type, transaction activity and custodian.',
  },
  {
    type: 'Wrap fees',
    description:
      'Bundles the investment management fees, brokerage transaction costs and custodial fees together for one price.',
    typicalCost: 'Varies by account size and type.',
  },
];

const COLUMNS = ['Fee type', 'Commonly associated with', 'Typical cost'];

const ROWS = FEE_STRUCTURES.map(row => ({
  id: row.type,
  cells: [row.type, row.description, row.typicalCost],
}));

export function FeeStructureTable() {
  return (
    <Details
      variant="simple"
      className="mt-2 block border-y border-border"
      summaryComponentProps={{
        className:
          'w-full justify-between px-2 py-3 hover:bg-secondary sm:hover:outline-2 sm:hover:outline-ring',
      }}
      SummaryComponent={
        <>
          <span className="typography-text-bold">
            For an overview of common fee structures, tap below.
          </span>
          <ExpandMoreIcon className="size-5 opacity-55 transition-transform group-open:rotate-180" />
        </>
      }
    >
      <RiaTable
        aria-label="Financial advisor fee structures"
        columns={COLUMNS}
        rows={ROWS}
        footer={
          <div className="typography-text-small space-y-2 p-4">
            <p>
              To compile this information, we reviewed industry studies on average rates among
              financial advisors. Information is accurate as of May 11, 2026. Studies included:
            </p>
            <p className="pl-4">
              State of Financial Planning and Fees study (Envestnet, a company that develops
              software for the wealth management industry).
            </p>
            <p className="pl-4">
              How Financial Planners Actually Do Financial Planning from Kitces.com.
            </p>
            <p>
              We also reviewed fees charged by providers reviewed by the NerdWallet investing team.
            </p>
          </div>
        }
      />
    </Details>
  );
}
